<template>
  <div class="row">
    <div class="col-md-12">
      <div class="category-top-bar" ref="optionsTopBar">
        <div class="top-bar">
          <a class="btn btn-orange btn-icon back" :title="$t('general.back')" @click.prevent="goBack">
            <i class="ti-arrow-left"></i>
            {{ $t('general.back') }}
          </a>
        </div>
      </div>
      <p class="clearfix"></p>
      <campaign-form :route="route" @on-submit="onCampaignSubmit"></campaign-form>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Select, Option} from 'element-ui'
  import CampaignForm from './CampaignForm.vue'
  Vue.use(Select)
  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      CampaignForm
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        campaignModel: {},
        campaign: {},
        modelValidations: {
          required: true
        }
      }
    },
    methods: {
      onCampaignSubmit (model, isValid) {
        this.campaignModel = model
      },
      goBack () {
        this.$bus.$emit('refresh')
        this.$bus.$emit('close-modal')
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Marketing/Campaigns/CampaignEdit.vue